export default "__VITE_ASSET__BFnF77MZ__"